export default __webpack_public_path__ + "static/media/mo.906af564.svg";